export default __webpack_public_path__ + "static/share-replay-dark-mode-1f373d5f5c69679a5a4dde4504aae790.mp4";